export default __webpack_public_path__ + "static/media/areeg.93fbecd5.jpg";